import { PropsWithChildren } from 'react';
import { useI18n } from 'next-localization';

import { Badges } from '@/components/badges';
import { cn } from '@/lib/utils';

import styles from '../profile.module.css';
import { DetailsSectionProps } from '../profile.types';

const Title = ({ children }: PropsWithChildren) => {
  return <p className={cn('mb-0 fw-heavy', styles.detailsTitle)}>{children}</p>;
};

export const DetailsSection = ({
  activeLocation,
  providerSpecialties,
  gender,
  telehealthProvider,
  languages,
}: DetailsSectionProps): JSX.Element => {
  const { t } = useI18n();

  return (
    <div className="col-xs-12 col-lg-8 mt-lg-2">
      <div className="row">
        <div className="col-6 col-sm-4 col-lg-3 mt-2">
          <Title>{t('OAS.Profile.Details.Phone')}</Title>
          <p>
            <a
              href={`tel:${
                activeLocation?.phone || activeLocation?.relatedContactCenterPhoneNumber
              }`}
              aria-label={t('OAS.Profile.Details.CallPhoneAriaLabel', {
                phone: activeLocation?.phone,
              })}
            >
              {activeLocation.phone || activeLocation?.relatedContactCenterPhoneNumber}
            </a>
          </p>
        </div>
        <div className="col-6 col-sm-4 mt-2">
          <Title>{t('OAS.Profile.Details.Specialty')}</Title>
          <p className={styles.detailsSpecialtyText}>
            {providerSpecialties.find((specialty) => specialty.primary)?.specialty}
          </p>
        </div>
        <div className="col-6 col-sm-5 d-none d-lg-block mt-2">
          <Badges
            acceptsNewPatients={activeLocation.acceptsNewPatients}
            telehealthProvider={telehealthProvider}
          />
        </div>
        <div className="col-6 col-sm-4 col-lg-3 mt-2">
          <Title>{t('OAS.Profile.Details.Gender')}</Title>
          <p>{gender}</p>
        </div>
        <div className="col-6 col-sm-4 mt-2">
          <Title>{t('OAS.Profile.Details.Languages')}</Title>
          <p className="d-flex flex-column">
            {languages.map((language, index) => (
              <span key={`language-${+index}`}>{language}</span>
            ))}
          </p>
        </div>
        <div className="col-6 col-sm-5 d-lg-none mt-2">
          <Badges
            acceptsNewPatients={activeLocation.acceptsNewPatients}
            telehealthProvider={telehealthProvider}
          />
        </div>
      </div>
      <div className={styles.detailsSelfPay}>
        <span className="neu-text--regular">{t('OAS.Profile.Details.SelfPayPatient')}</span>
      </div>
    </div>
  );
};
